// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sgeneeEr667Z_F5CiBu3{margin-top:20px}`, "",{"version":3,"sources":["webpack://./src/components/PublishJobsForm/PublishJobsForm.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA","sourcesContent":[".NotAvailableAlert {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NotAvailableAlert": `sgeneeEr667Z_F5CiBu3`
};
export default ___CSS_LOADER_EXPORT___;
